import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import PaginationComponent from '../Pagination/Pagination';

import shape from '../../../assets/resources/shape.png';
import { formatMainVariant, formatProductReviews } from '../../../helpers/shop/shopHelper';

import {
    Alert, Button, Box, Grid, Typography, Stack, Pagination, useMediaQuery
} from '@mui/material';

const ShopProducts = ({ filteredProducts, category, myRef }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const matches = useMediaQuery('(max-width: 500px)')
    const match_pag = useMediaQuery('(max-width: 374px)')

    //Pagination
    let [page, setPage] = useState(1);
    const PER_PAGE = matches ? 8 : 16;

    const count = Math.ceil(filteredProducts.length / PER_PAGE);
    const _DATA = PaginationComponent(filteredProducts, PER_PAGE);

    const handleChangePagination = (e, p) => {
        setPage(p);
        _DATA.jump(p);
        myRef.current.scrollIntoView()
    };

    return (
        <Grid item xl={10} lg={9} md={12} sm={12} xs={12}>
            <Grid container spacing={3}>
                {
                    filteredProducts.length <= 0 ?
                        <Grid item xs={12}>
                            <Alert severity="info"
                                action={
                                    <Button color="inherit" size="small"
                                        onClick={ () => navigate('/tienda') }>
                                        Ver Tienda
                                    </Button>
                                }>
                                {
                                    category === '' ?
                                        'No se ha encontrado la categoría'
                                    :
                                        `Ningún producto coincide con la categoría ${category}`
                                }
                            </Alert>
                        </Grid>
                    :
                        _DATA.currentData().map(({
                            _id, title, url, prod_variants, review_summary
                        }) => {
                            const {
                                MainVariant:
                                { full_title, price, barcode, item_promotion, img }
                            } = formatMainVariant(title, prod_variants);
                            // unique, min_price, max_price,
                            // reseñas de producto
                            const { review_prom, review_count } = formatProductReviews(review_summary);
                            const { promo, price: promo_price, text, fontSize, description: promotionDescription } = item_promotion;

                            return (
                                <Grid item xl={3} lg={4} md={4} sm={6} xs={12} key={_id}>
                                    <Grid container spacing={2}>
                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={5} sx={{ my: 'auto', textAlign: 'center' }}>
                                            <Link to={`/tienda/producto/${url}/${barcode}`}
                                                state={{ previousPath: pathname }}>
                                                <div className="product-in-promotion">
                                                    <img src={ img.id }
                                                        width='100%' style={{ objectFit: 'contain' }}
                                                        className="shop-product" alt={ img.alt }
                                                    />
                                                    {
                                                        promo !== '' &&
                                                        <div className="shop_top-image" title={promotionDescription}>
                                                            <img src={shape} alt={shape} width='75' style={{ pointerEvents: 'none' }} />
                                                            <div className="shop_centered_image">
                                                                <Typography sx={{ color: '#fff', fontSize, fontWeight: 'bold' }}>
                                                                    { text }
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </Link>
                                        </Grid>

                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={7} sx={{ my: 'auto' }}>
                                            <Link to={`/tienda/producto/${url}/${barcode}`}
                                                className="text-reset text-decoration-none">
                                                <Typography
                                                    sx={{ fontWeight: '600', textAlign: { xs: 'left', sm: 'center', md: 'center' } }}
                                                    variant="body1"
                                                    component="div"
                                                >
                                                    { full_title }
                                                </Typography>
                                            </Link>

                                            {/* <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' } }}>
                                                {
                                                    unique ?
                                                        <Typography variant='h6' sx={{ color: '#F90606', fontWeight: '600' }}>
                                                            ${price}
                                                        </Typography>
                                                    :
                                                        <Typography variant='h6' sx={{ color: '#F90606', fontWeight: '600' }}>
                                                            ${min_price} - ${max_price}
                                                        </Typography>
                                                }
                                            </Box> */}
                                            <Box sx={{
                                                display: 'flex', mt: 1,
                                                justifyContent: { xs: 'center', sm: 'center', md: 'center' },
                                            }}>
                                                {
                                                    ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="baseline"
                                                            spacing={1}>
                                                            <Typography variant="h6"
                                                                sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                                ${price}
                                                            </Typography>
                                                            <Typography variant="h6"
                                                                sx={{ fontWeight: '600', color: '#F90606' }} align='center'>
                                                                ${promo_price}
                                                            </Typography>
                                                        </Stack>
                                                    :
                                                        <Typography variant="h6"
                                                            sx={{ fontWeight: '600', color: '#F90606' }} align='center'>
                                                            ${price}
                                                        </Typography>
                                                }
                                            </Box>

                                            <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' } }}>
                                                <div className="ratings-shop">
                                                    {
                                                        review_count > 0 ?
                                                            Array.from(Array(review_prom), (e, j) => {
                                                                return <i className="fas fa-star"
                                                                    style={{
                                                                        color: '#FFA41C',
                                                                        stroke: "#FFA41C",
                                                                        strokeWidth: 0.2
                                                                    }}
                                                                    key={j}></i>
                                                            })
                                                        :
                                                            <>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                            </>
                                                    }
                                                </div>
                                            </Box>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                }
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: matches ? 'center' : 'flex-end', mt: 3 }}>
                <Pagination
                    size={match_pag ? 'small' : 'medium'}
                    color="primary"
                    count={count}
                    page={page}
                    onChange={handleChangePagination}
                />
            </Box>
        </Grid>
    );
};

export default ShopProducts;
